export function initAvailabilityAmount() {
    const transformAvailabilityAmount = () => {
        $('.availability-amount').each(function () {
            const amountElement = $(this)
            const amountText = amountElement.text().match(/\d+/)
            if (amountText) {
                const amount = parseInt(amountText[0])
                if (amount > 15) {
                    amountElement.text('(> 15 db)')
                }
            }
            amountElement.addClass('ready')
        })
    }

    transformAvailabilityAmount()

    document.addEventListener('ShoptetDOMPageContentLoaded', transformAvailabilityAmount)
    document.addEventListener('ShoptetDOMPageMoreProductsLoaded', transformAvailabilityAmount)
    document.addEventListener('ShoptetDOMAdvancedOrderLoaded', transformAvailabilityAmount)
    document.addEventListener('ShoptetDOMCartContentLoaded', transformAvailabilityAmount)
}
